var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRibbon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 10 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M8 0H2C.897 0 0 .897 0 2v21.5a.5.5 0 00.854.354L5 19.708l4.146 4.146a.499.499 0 00.549.107A.5.5 0 0010 23.5V2c0-1.103-.897-2-2-2zm1 22.293l-3.646-3.646a.498.498 0 00-.708 0L1 22.293V2a1 1 0 011-1h6a1 1 0 011 1v20.293z"
})));
export default SvgRibbon;